export default "__VITE_ASSET__CO4c0Z5f__"